export enum ExperienceFeatures {
  GlobalChat = 'GLOBAL_CHAT',
  PrivateChat = 'PRIVATE_CHAT',
  Broadcast = 'BROADCAST',
  Hoverboard = 'HOVERBOARD',
  Camera = 'CAMERA',
  Mic = 'MIC',
  Participants = 'PARTICIPANTS',
  OnlineUsers = 'ONLINE_USERS',
  Teleport = 'TELEPORT',
  LaserPointer = 'LASER_POINTER',
  Magnifier = 'MAGNIFIER',
  Emojis = 'EMOJIS',
  Reactions = 'REACTIONS',
  Map = 'MAP',
}

export interface IBaseFeatureConfig {
  enabled: boolean;
}

export interface IExperienceFeatureSettings {
  GLOBAL_CHAT?: IBaseFeatureConfig;
  PRIVATE_CHAT?: IBaseFeatureConfig;
  BROADCAST?: IBaseFeatureConfig;
  HOVERBOARD?: IBaseFeatureConfig;
  CAMERA?: IBaseFeatureConfig;
  MIC?: IBaseFeatureConfig;
  PARTICIPANTS?: IBaseFeatureConfig;
  ONLINE_USERS?: IBaseFeatureConfig;
  TELEPORT?: IBaseFeatureConfig;
  LASER_POINTER?: IBaseFeatureConfig;
  MAGNIFIER?: IBaseFeatureConfig;
  EMOJIS?: IBaseFeatureConfig;
  REACTIONS?: IBaseFeatureConfig;
  MAP?: IBaseFeatureConfig;
}
